

// Safari の hover-stuck バグを完全に解除
document.addEventListener("DOMContentLoaded", () => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (!isSafari) return;

  // すべての product-card の hover クラスを初期化
  const cards = document.querySelectorAll("product-card, .product-card");

  cards.forEach(card => {
    // 初期状態で hover が誤判定されていたら削除する
    card.classList.remove("hover");
    card.classList.remove("is-hovering");

    // Safari が hover を固定しないよう、pointer-events を一度リセット
    card.style.pointerEvents = "none";

    // 少し遅延してから pointer-events を戻す（これが決め手）
    setTimeout(() => {
      card.style.pointerEvents = "auto";
    }, 50);
  });
});

















